<div class="flex flex-column gap-200">
  <div class="flex">
    <button *ngIf="!!authService.loggedUser$.value?.editService"
            (click)="openCreateServiceDrawer()" style="margin-left: auto" nz-button nzType="primary" nzShape="round"
            [disabled]="ps.selectedService && ps.selectedService.serviceOrders && ps.selectedService.serviceOrders.length > 0"
            [nz-tooltip]="ps.selectedService && ps.selectedService.serviceOrders && ps.selectedService.serviceOrders.length > 0
            ? 'No puedes editar el flujo porque ya hay órdenes de servicio que lo están usando.' : ''"
            nzSize="default" class="text-btn-14">
      <app-st-icon class="prefix" [name]="'edit'" [bold]="true"></app-st-icon>
      <span>Editar flujo</span>
    </button>
  </div>

  <app-event-cards-dragables *ngIf="eventTypes"
                             [events]="eventTypes"
                             [isEditing]="false"
  ></app-event-cards-dragables>
</div>
